import { FishingWatersToggleableGroup } from '../../Maps/constants/mapLayers/fishingWaters';
import { LayerConfig, LayerName, ToggleableGroup } from '../../Maps/types/types';

export const activateFishingWaterLayerIfNeeded = ({
  hasCatches,
  isWholeLayerVisible,
  toggleableGroups,
  setNewLayerConfig,
}: {
  hasCatches: boolean;
  isWholeLayerVisible: boolean;
  toggleableGroups: ToggleableGroup[];
  setNewLayerConfig: (layer: LayerName, layerConfig: Omit<LayerConfig, 'setConfig'>) => void;
}): void => {
  const toggleableGroup: FishingWatersToggleableGroup = hasCatches
    ? 'FISHING_WATERS'
    : 'EMPTY_FISHING_WATERS';

  if (!isWholeLayerVisible || !toggleableGroups.includes(toggleableGroup)) {
    setNewLayerConfig('fishingWaters', {
      isWholeLayerVisible: true,
      toggleableGroups: toggleableGroups.includes(toggleableGroup)
        ? toggleableGroups
        : [...toggleableGroups, toggleableGroup],
    });
  }
};
